export var BillingProductsSlugType;
(function (BillingProductsSlugType) {
    BillingProductsSlugType["BILLING_MANAGEMENT"] = "billing-management";
    BillingProductsSlugType["BILLING_MANAGEMENT_NFSE"] = "billing-management-nfse";
    BillingProductsSlugType["BILLING_MANAGEMENT_REGUA"] = "billing-management-regua";
    BillingProductsSlugType["CLIENT_PORTAL"] = "client-portal";
    BillingProductsSlugType["VOUCHER_MANAGEMENT_SWAP"] = "voucher-management-swap";
})(BillingProductsSlugType || (BillingProductsSlugType = {}));
